// extracted by mini-css-extract-plugin
export var formContainer = "_hl-0";
export var message = "_hl-1";